import React from 'react';
import {useLocation} from "react-router-dom";
import UseContext from "hooks/useContext";

const NavBarTitle = () => {
    const route =useLocation()
    const {pathname}=route
    const path = pathname.split('/')
    const page=path[1]
    const {missionTitle, missionId} = UseContext()
    const PAGE ={
        'dashboard':'Tableau de bord',
        'profil':'Profil',
        'timeSheet':'Relevés d\'heures',
        'files':'Documents',
        'missions':'Missions',
        'contract':'Contrats',
        'invoice':'Factures',
        'personalInformations':'Mon Profil',
        'adminCompany':'Équipe',
        'createOfMission':'Création de missions',
        'activityCompany':'Activités'
    }
    
    // Si on est sur une sous-page de profil, afficher "Profil"
    const isProfilPage = pathname.includes('/profil')
    
    // Si on est sur une page de mission détaillée, afficher le titre de la mission
    const isMissionDetailPage = pathname.includes('/mission/') && pathname !== '/missions'
    
    return (
        <>
            <div className="flex">
                <span className='ft-lg text-gray-700'>
                    {isMissionDetailPage 
                        ? 'Détail de la mission'
                        : isProfilPage 
                            ? 'Profil' 
                            : (PAGE[page] || '')
                    }
                </span>
            </div>
        </>
    );
};

export default NavBarTitle;